import React from 'react'

import { Slider } from '@/components/molecules/slider'
import { SwatchGrid } from '@/components/molecules/swatch-grid'

import {
  ImageEditorAdjustments,
  ImageEditorEngine,
} from '../image-editor.types'
import { FILTERS } from '../picture-studio-engine'

const SLIDERS: {
  key: Exclude<keyof ImageEditorAdjustments, 'filter'>
  label: string
  suffix: string
  min: number
  max: number
}[] = [
  { key: 'brightness', label: 'Brightness', suffix: '%', min: 0, max: 200 },
  { key: 'contrast', label: 'Contrast', suffix: '%', min: 0, max: 200 },
  { key: 'saturate', label: 'Saturation', suffix: '%', min: 0, max: 200 },
  { key: 'sepia', label: 'Warmth', suffix: '%', min: 0, max: 100 },
  { key: 'blur', label: 'Blur', suffix: 'px', min: 0, max: 12 },
  { key: 'hue', label: 'Hue', suffix: '°', min: 0, max: 360 },
]

interface PanelAdjustProps {
  adjustments: ImageEditorAdjustments
  engine: ImageEditorEngine
}

export function PanelAdjust({ adjustments, engine }: PanelAdjustProps) {
  return (
    <div>
      {SLIDERS.map((s) => (
        <div key={s.key} className="mb-3">
          <div className="mb-1 flex justify-between text-xs">
            <span>{s.label}</span>
            <span className="tabular-nums text-light-4">
              {adjustments[s.key]}
              {s.suffix}
            </span>
          </div>
          <Slider
            min={s.min}
            max={s.max}
            step={1}
            value={[adjustments[s.key]]}
            onValueChange={([v]) => engine.setAdjustment(s.key, v)}
          />
        </div>
      ))}
      <div className="my-3.5 h-px bg-neutral-1" />
      <span className="mb-2 block text-xs text-light-4">Artistic filters</span>
      <SwatchGrid
        columns={2}
        value={adjustments.filter}
        onSelect={(id) => engine.setFilter(id)}
        items={FILTERS.map((f) => ({ value: f.id, label: f.name }))}
      />
    </div>
  )
}
